// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"ad5bfc2b","administration":"e5142b2a","src_main_webapp_app_shared_util_donor-collect_ts":"5e2aaa48"}[chunkId] + ".chunk.js";
};